module.exports = __webpack_public_path__ + "img/Color 03.e790741a.jpg";